import React from 'react';
import StatusFilter from '../../../../pages/DashboardNew/components/StatusFilter';

interface StrategymapSidePanelSearchProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  placeholder: string;
  statusFilters: string[];
  setStatusFilters: (filters: string[]) => void;
  statusDropdownOpen: boolean;
  setStatusDropdownOpen: (open: boolean) => void;
  showStatusFilter?: boolean;
  filterType?: 'task' | 'project' | 'smap';
  className?: string;
  statusCounts?: Record<string, number>;
}

export const StrategymapSidePanelSearch: React.FC<StrategymapSidePanelSearchProps> = ({
  searchValue,
  onSearchChange,
  placeholder,
  statusFilters,
  setStatusFilters,
  statusDropdownOpen,
  setStatusDropdownOpen,
  showStatusFilter = true,
  filterType = 'smap',
  className = '',
  statusCounts
}) => {
  return (
      <div className={`flex items-center  ${className} border border-light-border-default dark:border-slate-800 rounded-xl bg-light-surfacePrimary dark:bg-tertiary-dark shadow-sm hover:shadow-md transition-all duration-200 focus-within:border-light-border-focus focus-within:ring-2 focus-within:ring-primary-light/20 focus:outline-none justify-center w-full gap-1`} style={{ minHeight: 44 }}>
        {showStatusFilter && (
          <>
            <StatusFilter
              statusFilters={statusFilters}
              setStatusFilters={setStatusFilters}
              isOpen={statusDropdownOpen}
              setIsOpen={setStatusDropdownOpen}
              filterType={filterType}
              statusCounts={statusCounts}
            />
            <div className="h-6 w-px bg-light-border-subtle dark:bg-gray-700 mx-1" />
          </>
        )}
        <input
          type="text"
          className="w-full flex-1 px-4 bg-transparent font-normal text-xs text-light-text-primary dark:text-gray-300  py-2 focus:outline-none focus:ring-0 placeholder:text-light-input-placeholder dark:placeholder-gray-400 border-none min-w-0"
          placeholder={placeholder}
          value={searchValue}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>
  );
};

export default StrategymapSidePanelSearch;
